export const handleFBQ = (v) => {
	if (window?.fbq) {
        window.fbq('track', v);
    }
}
